export const GROWING_TAG = "Growing";

export const DECLINING_TAG = "Declining";
